import React from 'react';
import CellContainer from '../CellContainer';
import EvolutionIcon from '../../EvolutionIcon';

const Cell = ({ value, ...otherProps }) => (
  <CellContainer {...otherProps}>
    <EvolutionIcon icon={value ? 'check' : 'close'} />
  </CellContainer>
);

export default Cell;
